import { render, staticRenderFns } from "./greenChain.vue?vue&type=template&id=35094c4a&scoped=true"
import script from "./greenChain.vue?vue&type=script&lang=js"
export * from "./greenChain.vue?vue&type=script&lang=js"
import style0 from "./greenChain.vue?vue&type=style&index=0&id=35094c4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35094c4a",
  null
  
)

export default component.exports